module.exports = __webpack_public_path__ + "img/direct_messages.df5dcaa1.svg";